import { PAGE_POSITIONS } from 'types';
import type { CapiPlp } from 'types/capi/plp';
import { PlpModule } from 'types/capi/plp';

import type { SplashSlideModuleType } from '~/events/SplashSlideInteractionEvent';
import usePageData from '~/hooks/usePageData';
import HeaderCarousel, { Variant } from '~/modules/HeaderCarousel';

function ModuleSection({
  isFullBleed,
  moduleType,
  sectionModules,
  position,
  variant
}: {
  isFullBleed: boolean;
  moduleType: SplashSlideModuleType;
  position: PAGE_POSITIONS;
  sectionModules: PlpModule[] | undefined;
  variant: Variant;
}) {
  return sectionModules?.map((m) => {
    switch (m.type) {
      case 'HEADER_CAROUSEL':
        return (
          <HeaderCarousel
            variant={variant}
            isFullBleed={isFullBleed}
            analytics={{ id: 'PLP_CAROUSEL', position }}
            module={m}
            moduleType={moduleType}
          />
        );
    }
  });
}

export function TopModuleSection() {
  const { top_section_modules } = usePageData<CapiPlp>();

  return (
    <ModuleSection
      variant="small-lg-font"
      isFullBleed
      moduleType="plp-top-banner"
      position="PLP Top Modules"
      sectionModules={top_section_modules}
    />
  );
}

export function MidModuleSection() {
  const { mid_section_modules } = usePageData<CapiPlp>();

  return (
    <div className="col-span-full -mx-4 md:-mx-8 desktop:mx-0 desktop:max-w-desktop">
      <ModuleSection
        variant="small-md-font"
        isFullBleed={false}
        moduleType="plp-mid-banner"
        position="PLP Mid Modules"
        sectionModules={mid_section_modules}
      />
    </div>
  );
}
